module.exports = __webpack_public_path__ + "media/assets/images/flags/pf-0c8821d32e0343624b77fa2ba758de44.svg";